import { useSelector } from 'react-redux';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Link, Typography } from '@mui/material';

import { AlertMessage } from '~/pages/CreateQR/sub-components/pdfTemplate/sub-components/AlertMessage';
import { getPdfReducer } from '~/store/reducers/previewScreens/pdf/selectors';
import { COLORS } from '~/styles/colors';
import { mainPreviewContainerStyles } from '~/styles/common';

type PDF_TEMPLATE_4Props = {
  isMyMicrosite?: boolean;
};
export function PDF_TEMPLATE_4({ isMyMicrosite }: PDF_TEMPLATE_4Props) {
  const pdfState = useSelector(getPdfReducer);

  const {
    bacgkroundColor,
    micrositeStyles,
    fonts: { head, text },
    basicInformation: { images, coverImage },
    pdfInformation: { company, title, description, website },
  } = pdfState;

  return (
    <Box
      sx={{
        ...mainPreviewContainerStyles,
        alignItems: 'normal',
        position: 'relative',
        background: `linear-gradient(180deg, ${bacgkroundColor[0]} 0%, ${bacgkroundColor[1]} 100%);`,
        ...micrositeStyles?.container,
        margin: isMyMicrosite ? undefined : '0 12px',
        width: isMyMicrosite ? '100%' : 'calc(100% - 24px)',
        height: 'calc(100% - 28px)',
        ...(isMyMicrosite ? { borderRadius: 0, minHeight: '100dvh' } : {}),
      }}
    >
      {!!images.length || company || title || description || website ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            minWidth: '100%',
          }}
        >
          <Typography
            sx={{
              fontFamily: text,
              fontSize: 12,
              mt: 3,
              mb: 3,
              padding: '0 1rem',
              wordBreak: 'break-word',
              color: COLORS.white,
            }}
          >
            {company}
          </Typography>
          <Box sx={{ padding: '0 1rem', position: 'relative', mt: coverImage ? 7 : 0 }}>
            <Box
              sx={{
                backgroundColor: COLORS.white,
                mb: 2,
                boxShadow: `0 2.6px 13px 0 ${COLORS.textMainOpacity15}`,
                borderRadius: '12px',
              }}
            >
              {!!coverImage?.img && (
                <Box
                  sx={{
                    backgroundColor: COLORS.white,
                    borderRadius: '50%',
                    width: 78,
                    height: 78,
                    padding: '8px',
                    display: 'flex',
                    margin: '0 auto',
                    position: 'absolute',
                    top: '-39px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    boxShadow: `0 2.6px 13px 0 ${COLORS.textMainOpacity15}`,
                  }}
                >
                  <img
                    src={coverImage.img}
                    style={{ width: '62px', height: '62px', borderRadius: '50%', objectFit: 'cover' }}
                    alt="cover"
                  />
                </Box>
              )}
              <Box sx={{ padding: 1 }}>
                <Typography
                  sx={{
                    fontFamily: head,
                    fontSize: 18,
                    mb: 2,
                    mt: coverImage ? 6 : 2,
                    color: COLORS.black,
                    wordBreak: 'break-word',
                  }}
                >
                  {title}
                </Typography>
                <Typography
                  sx={{ fontFamily: text, fontSize: 10, mb: 1, color: COLORS.black, wordBreak: 'break-word' }}
                >
                  {description}
                </Typography>
              </Box>
              {images.map((item, index) => {
                return (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      minHeight: 44,
                      padding: 1.5,
                      borderTop: `1px solid ${COLORS.black01}`,
                    }}
                    onClick={() => window.open(item?.previewPdfLink, '_blank')}
                    key={index}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {item?.previewLink ? (
                        <img
                          src={item?.previewLink}
                          style={{ height: 28, width: 28, objectFit: 'cover', borderRadius: '8px' }}
                          alt="cover"
                        />
                      ) : null}
                      <Box sx={{ ml: 1, textAlign: 'left' }}>
                        <Typography sx={{ color: COLORS.black, fontSize: 11, wordBreak: 'break-word' }}>
                          {item?.name || item?.path}
                        </Typography>
                        <Typography sx={{ color: COLORS.disableGrayColor, fontSize: 11, wordBreak: 'break-word' }}>
                          {item?.description}
                        </Typography>
                      </Box>
                    </Box>
                    <ChevronRightIcon sx={{ color: COLORS.disableGrayColor, fontSize: '16px' }} />
                  </Box>
                );
              })}
            </Box>

            <Typography sx={{ fontFamily: text, fontSize: 13, mt: 2, mb: 2 }}>
              <Link
                href={website}
                target="_blank"
                sx={{ textDecoration: 'none', color: COLORS.white, wordBreak: 'break-word', pl: 1, pr: 1 }}
              >
                {website}
              </Link>
            </Typography>
          </Box>
        </Box>
      ) : (
        <AlertMessage />
      )}
    </Box>
  );
}
